import { number, object } from 'yup';

export const siteDetailsReportValidation = object().shape({
  cityId: number().typeError('שדה חובה').required('שדה חובה'),
  siteId: number().typeError('שדה חובה').required('שדה חובה'),
});
